<template>
  <BContainer class="mt-5 py-4 border-top">
    <BRow class="align-items-center">
      <!-- Logo -->
      <BCol class="text-center">
        <img src="@/assets/logo.png" alt="嘎嘎狗 Logo" class="footer-logo" />
      </BCol>
    </BRow>
    <BRow>
      <BCol class="text-center text-muted">
        © 2025 嘎嘎狗. 版權所有.
      </BCol>
    </BRow>
  </BContainer>
</template>

<script setup>
import { BContainer, BRow, BCol } from "bootstrap-vue-next";
</script>

<style scoped>
.footer-logo {
  max-width: 150px; /* 控制 logo 的寬度 */
  height: auto; /* 保持圖片比例 */
  margin-bottom: 1rem; /* 與文字保持間距 */
}
</style>
